import {Injectable} from '@angular/core';
import {AppConfigService} from '../services/appConfig.service';

@Injectable()
export class HabaServices {
    constructor(private configService: AppConfigService) {}

    habaLogin(data = {}, nav: any) {
        data["flag"] = 'HabaLoginBean_habalogin';
        return this.configService.getHabaLogin(data, nav);
    }

    habaGetBalance(data = {}, nav: any) {
        data["flag"] = 'HabaGamesBean_habaCheckBalance';
        return this.configService.getHabaBalance(data, nav);
    }

    habaTransferBalance(data = {}, nav: any) {
        let flag = data["direction"] === 2 ? "HabaGamesBean_habaFundTransferDeposit" : "HabaGamesBean_habaFundTransferWithdraw";
        data["flag"] = flag;
        return this.configService.getHabaTransferBalance(data, nav);
    }
}



// WEBPACK FOOTER //
// ./src/services/haba.services.ts